<template>
  <div class="about full-paddings med-width text-center">
    <h1>About</h1>
    <p>
      I am a Northand-based creative, with 8+ years of experience designing and
      creating interfaces.
    </p>
  </div>
</template>
